/**
 * Quando o detalhe vale e até onde vai — lido pelo motor e pelo controlador do
 * loop (que não podem importar um ao outro).
 *
 * - Automática e "Máxima": sem teto (o maior nível que o produto tem).
 * - "Alta" (3600): os blocos chegam até 3600. A base continua leve: a
 *   qualidade escolhida é o teto da nitidez, não o tamanho do arquivo baixado.
 * - "Padrão"/"Leve" (1800/900): a imagem inteira nessa largura, sem blocos.
 * - Conexão econômica (conexao.ts): teto 3600 em qualquer caso.
 */
import type { QualityMode } from '../goes/budget';
import { useLoopStore } from '../loop/store';
import { LARGURA_BASE } from './blocos';
import { conexaoEconomica } from './conexao';
import { blocosDisponiveis } from './saude';

/** Teto conexão econômica. */
export const TETO_ECONOMICO = 3600;

/** Maior nível de detalhe permitido (px; Infinity = sem teto). Puro — testado. */
export function tetoDoDetalhe(quality: QualityMode, economica: boolean): number {
  const q = quality === 'auto' || quality === 7200 ? Infinity : quality;
  return economica ? Math.min(q, TETO_ECONOMICO) : q;
}

/** O detalhe vale agora? (servidor de blocos no ar e teto acima da base) */
export function detalheLigado(): boolean {
  return blocosDisponiveis() && tetoDoDetalhe(useLoopStore.getState().quality, conexaoEconomica()) > LARGURA_BASE;
}

/**
 * Modo da BASE (imagem inteira) para o controlador: com o detalhe ligado, a
 * base segue a automática (limitada pela largura da base), também quando a
 * qualidade é fixa — a nitidez escolhida vem pelos blocos.
 */
export function modoDaBase(quality: QualityMode, ligado: boolean): QualityMode {
  return ligado ? 'auto' : quality;
}
